import { ContentContainer, OverlayContainer, OverlayContent, OverlayLayer } from './styles';
import Loading from '@doordash/component-loading';
import PropTypes from 'prop-types';
import React from 'react';
import { ThemingContext } from '@doordash/design-language';
import { Types } from './constants';

var Overlay = function Overlay(_ref) {
  var isAnimated = _ref.isAnimated,
      isVisible = _ref.isVisible,
      children = _ref.children,
      type = _ref.type,
      onClick = _ref.onClick,
      content = _ref.content;
  var theme = React.useContext(ThemingContext);
  return React.createElement(OverlayContainer, {
    onClick: isVisible ? onClick : null
  }, React.createElement(OverlayContent, null, children), React.createElement(OverlayLayer, {
    isAnimated: isAnimated,
    kind: type,
    isVisible: isVisible,
    themeColors: {
      OverlayBackgroundLoading: theme.Colors.OverlayBackgroundLoading,
      OverlayBackgroundDefault: theme.Colors.OverlayBackgroundDefault
    }
  }), isVisible && (type === Types.Loading || content) && React.createElement(ContentContainer, null, content || React.createElement(Loading, {
    color: theme.Colors.OverlayLoadingDefault
  })));
};

Overlay.Types = Types;
Overlay.propTypes = {
  onClick: PropTypes.func,
  isAnimated: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
  children: PropTypes.node,
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  type: PropTypes.oneOf(Object.values(Types))
};
Overlay.defaultProps = {
  isAnimated: true,
  isVisible: false,
  type: Types.Dark
};
export default Overlay;